import { render, staticRenderFns } from "./ProgrammeSection.vue?vue&type=template&id=76525e21&lang=pug&"
import script from "./ProgrammeSection.vue?vue&type=script&lang=js&"
export * from "./ProgrammeSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports